import { formatCurrencyAmount, resolveDocumentCurrency } from '@/common/domain/kit/money';
import { normalizeLineItemsColumnKey } from '@/blocks/domain/helpers/lineItemsColumnKeys';
import { isPriceBookNumericColumn } from '@/blocks/domain/helpers/priceBookColumnKeys';
import { resolveContextCultureTag } from './customerLocaleFormatters';

export function isLineItemsMoneyColumn(key: string): boolean {
  const normalized = normalizeLineItemsColumnKey(key);
  return normalized === 'rate' || normalized === 'total' || normalized === 'cost';
}

export function formatLineItemsCellValue(value: unknown, columnKey: string, currency: string, cultureTag = 'en-US'): string {
  if (value == null || value === '') {
    return '—';
  }

  if (isLineItemsMoneyColumn(columnKey)) {
    const amount = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(amount)) {
      return String(value);
    }
    return formatCurrencyAmount(amount, currency, cultureTag);
  }

  return String(value);
}

export function formatPriceBookCellValue(value: unknown, columnKey: string, currency: string, cultureTag = 'en-US'): string {
  if (value == null || value === '') {
    return '—';
  }

  if (isPriceBookNumericColumn(columnKey)) {
    const amount = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(amount)) {
      return String(value);
    }
    return formatCurrencyAmount(amount, currency, cultureTag);
  }

  return String(value);
}

/** Resolves document currency: record → optional org fallback → USD. */
export function resolveContextCurrency(context: Record<string, unknown>, fallbackCurrency?: string | null): string {
  return resolveDocumentCurrency(context, fallbackCurrency);
}

export { resolveContextCultureTag };
